import axios from "axios";
import { API } from "../const/API";

/** Единый клиент API: baseURL и cookies для сессии. */
export const httpClient = axios.create({
    baseURL: API,
    withCredentials: true,
});
